import type { ReactNode } from "react";
import logo2x from "@/assets/logo@2x.png";
import logo3x from "@/assets/logo@3x.png";
import logo from "@/assets/logo.png";
import { Heading } from "@/components/ui/typography";

const AUTH_BACKGROUND_IMAGE = "/images/auth/construction-site.jpg";

type AuthShellProps = {
  title: string;
  description?: string;
  children: ReactNode;
};

export function AuthShell({ title, description, children }: AuthShellProps) {
  return (
    <div className="grid min-h-svh md:grid-cols-2">
      <div
        className="relative hidden flex-col justify-end bg-cover bg-center p-8 md:flex lg:p-12"
        style={{ backgroundImage: `url("${AUTH_BACKGROUND_IMAGE}")` }}
      >
        <div
          className="absolute inset-0 bg-linear-to-t from-neutral-950/90 via-neutral-950/50 to-neutral-950/20"
          aria-hidden="true"
        />
        <div className="relative text-white">
          <img
            src={logo}
            srcSet={`${logo} 1x, ${logo2x} 2x, ${logo3x} 3x`}
            alt="OS04"
            className="mb-3 h-auto max-w-[150px] brightness-0 invert"
          />
          <p className="max-w-sm font-light text-white/80">
            Know who was on site, what was checked, and what can be proved
            later.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center bg-background px-4 py-8 md:px-6 md:py-12">
        <div className="w-full max-w-sm">
          <div className="mb-8 flex flex-col items-center text-center">
            <img
              src={logo}
              srcSet={`${logo} 1x, ${logo2x} 2x, ${logo3x} 3x`}
              alt="OS04"
              className="mb-6 h-auto max-w-[150px] md:hidden"
            />
            <Heading variant="page" className="leading-tight">
              {title}
            </Heading>
            {description ? (
              <p className="mt-3 max-w-sm text-sm text-muted-foreground md:text-base">
                {description}
              </p>
            ) : null}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
